import { Paragraph } from '@eggplant/pattern-library'
import { models } from '../../docs-routes'
import LinkToDocusaurus from '../LinkToDocusaurus'

interface Props {
  isGlobal?: boolean
  isLoggedSpace?: boolean
}

const editableMessage = 'Add or remove members and assign roles specific to this space. '
const membersDescription = 'Note that these roles apply only within this space. DAI also has its own set of global roles and permissions.'
const globalDescription = 'The shared space is accessible to all users, with their space roles matching their DAI roles. To view the full user list and roles, go to the Access page.'

const SpaceCreatedManageMembersInfo = ({
  isGlobal = false,
  isLoggedSpace = false
}: Props) =>{
  const description = isLoggedSpace
    ? membersDescription
    : editableMessage + membersDescription

  return (
    <Paragraph>
      <strong>
        {
          isGlobal
            ? globalDescription
            : description
        }
        <br />
        <LinkToDocusaurus path={models}>Learn more in the DAI documentation</LinkToDocusaurus>
      </strong>
    </Paragraph>
  )
}

export default SpaceCreatedManageMembersInfo
